/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Source_LabelInputs */



/**
* | output |
* | --- |
* | "Source" |
*
* @param {Audio_Embed_Export_Output_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_source_label = /** @type {((inputs?: Audio_Embed_Export_Output_Source_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Source_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fonte")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Источник")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("来源")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fonte")
	return /** @type {LocalizedString} */ ("Source")
});